
export { CollectionName } from "/codebuild/output/src1223345125/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"